export const cultureRegexString = '[a-z]{2}-[a-z]{2}';
export const cultureRegex = new RegExp(`^/${cultureRegexString}/`, 'i');
export const cultureRegexNoTrailing = new RegExp(`^/${cultureRegexString}`, 'i');
